
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referral-halloween",
      function () {
        return require("private-next-pages/referral-halloween/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referral-halloween"])
      });
    }
  